import { Box, BoxProps, ColorOptions, convertHexToRGBA, ImageProps, ModalDialogNew, TextProps } from '@jfs/ui-new'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs'
import { ParamListBase } from '@react-navigation/native'
import type { StackScreenProps } from '@react-navigation/stack'
import * as React from 'react'
import { useEffect, useLayoutEffect, useState } from 'react'
import {
  Alert,
  DeviceEventEmitter,
  Dimensions,
  InteractionManager,
  NativeEventEmitter,
  NativeModules,
  Platform,
} from 'react-native'
import DeviceInfo from 'react-native-device-info'
import { getLeftHeaderInTabNavigator } from '../../comps/CustomHeader/headerFunctionHelpers'
import { ScreenLockDialog } from '../../comps/ScreenLockDialog'
import { ToastType } from '../../comps/Toast'
import { loginStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'

import {
  getAppId,
  getFromStore,
  isOsMobile,
  isSessionValid,
  logEvent,
  NotificationServiceModule,
  ScreenLockModule,
  storeData,
} from '../../util/util'
import { TabBar } from './tabBar'

import Dashboard from '../../screens/Home/index.native'
import PaymentsStack from '../PaymentsStack'
import ProfileScreenStack from '../ProfileScreenStack'
import QrStack from '../QrStack'

const middleOrientationMinEntry: number = 3

const HOME = {
  id: '0',
  label: 'home',
  iconId: 'HomeTabIcon',
  navigateTo: '/',
  component: Dashboard,
}

const TRANSACTIONS = {
  id: '1',
  label: 'payments',
  iconId: 'RupeeTabIcon',
  navigateTo: 'transactions',
  component: PaymentsStack,
}

const QR = {
  id: '2',
  label: 'myQr',
  iconId: 'QrTabIcon',
  navigateTo: 'qr',
  component: QrStack, //UpiQRCode, //isMobile(false) ? QrStack : UpiQRCode,
}

const PROFILE = {
  id: '4',
  label: 'more',
  iconId: 'MoreTabIcon',
  navigateTo: 'NewProfile',
  component: ProfileScreenStack,
}

export let config: any = {
  home: HOME,
  transactions: TRANSACTIONS,
  qr: QR,
  // settlements: SETTLEMENTS,
  profile: PROFILE,
}

const Tab = createBottomTabNavigator()
type Props = Partial<React.ComponentProps<typeof Tab.Navigator>> & StackScreenProps<ParamListBase>

const NewTab = ({ navigation, route, isLoading, ...rest }: Props) => {
  const {
    isAppLockEnabled,
    setAppLockEnabled,
    setAppLockLater,
    isSetAppLockLater,
    sessionData,
    createUserDevice,
    sessAppAccessToken,
    userMobileNo,
    isTransactionTabEnabled,
    isQrEnabled,
    isSettlementTabEnabled,
    isReceivedTabVisible,
    isRefundedTabVisible,
    mid,
    setMessage,
    setToastType,
    selectedAppLanguage,
    reset,
    searchEntity,
    updateselectedMercMid,
    updateSelectedMercName,
    merchants,
    fetchPendingPairRequest,
  } = useStores((root) => ({
    isAppLockEnabled: root.settings.metaData.isAppLockEnabled,
    setAppLockEnabled: root.settings.metaData.setAppLockEnabled,
    setAppLockLater: root.settings.metaData.setAppLockLater,
    isSetAppLockLater: root.settings.metaData.isSetAppLockLater,
    sessionData: root.user.session,
    createUserDevice: root.user.createUserDevice,
    sessAppAccessToken: root?.user?.session?.appAccessToken,
    userMobileNo: root?.settings?.metaData?.mobileNumber,
    isTransactionTabEnabled: root.userManagement.isTransactionTabEnabled(),
    isQrEnabled: root.userManagement.isQrEnabled(),
    isSettlementTabEnabled: root.userManagement.isSettlementTabEnabled(),
    isReceivedTabVisible: root.userManagement.isReceivedTabVisible(),
    isRefundedTabVisible: root.userManagement.isRefundedTabVisible(),
    mid: root?.user.selectedMid,
    setMessage: root?.response?.setMessage,
    setToastType: root?.response?.setToastType,
    selectedAppLanguage: root.settings.config.selectedAppLanguage,
    reset: root?.reset,
    searchEntity: root?.user?.searchEntity,
    updateselectedMercMid: root?.user.updateSelectedMercMid,
    updateSelectedMercName: root.settings.metaData.updateSelectedMercName,
    merchants: root?.user?.merchants,
    fetchPendingPairRequest: root.voiceBoxes.fetchPendingPairRequest,
  }))
  const params: any = route?.params
  const [searchEntityApi, { state: searchEntityState, data: searchEntityData }] = useLazyApiData(searchEntity)

  const appLockEnabled = isOsMobile() && !isAppLockEnabled && !isSetAppLockLater && isSessionValid(sessionData)
  const [showApplock, setShowAppLock] = useState(false)

  useLayoutEffect(() => {
    navigation.setOptions({
      gestureEnabled: true,
      headerLeft: () => getLeftHeaderInTabNavigator(0),
      title: '',
    })
  }, [navigation])

  useEffect(() => {
    if (searchEntityState === 'fulfilled') {
      //console.log('test app searchEntityData success', searchEntityData)
    } else if (searchEntityState === 'rejected') {
      // TODO: logout the user
      console.log('test app searchEntityData failed', searchEntityData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchEntityState])

  useEffect(() => {
    if (mid) {
      searchEntityApi(mid)
    }
  }, [mid, searchEntityApi])

  const navigateToTransactionDetails = React.useCallback(
    ({ transactionId, merchantId }) => {
      setTimeout(() => {
        if (transactionId && merchantId) {
          const selectedMerchant = merchants?.find((item) => item.mid === merchantId)
          if (selectedMerchant) {
            updateselectedMercMid(merchantId)
            updateSelectedMercName(selectedMerchant.businessName)
            navigation?.navigate(Routes.TRANSACTIONS_DETAILS, {
              transactionId: transactionId,
              path: Routes.TRANSACTIONS,
            })
          }
        }
      }, 100)
    },
    [merchants, navigation, updateSelectedMercName, updateselectedMercMid],
  )

  useEffect(() => {
    navigateToTransactionDetails(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (Platform.OS === 'android') {
      const subscription = DeviceEventEmitter.addListener('PROCESS_BLUETOOTH_PAIR_REQUEST', () => {
        console.log('PROCESS_BLUETOOTH_PAIR_REQUEST event received')
        fetchPendingPairRequest(mid)
      })
      return () => {
        subscription?.remove()
      }
    }
  }, [fetchPendingPairRequest, mid])

  useEffect(() => {
    console.log('ON_TRANSACTION_ID_RECEIVED')

    if (Platform.OS === 'ios') {
      const { RNEventEmitter } = NativeModules
      let eventEmitter = new NativeEventEmitter(RNEventEmitter)
      const subscription = eventEmitter.addListener('ON_TRANSACTION_ID_RECEIVED', (res) => {
        console.log('ON_TRANSACTION_ID_RECEIVED response:', res)
        navigateToTransactionDetails(res)
      })
      return () => {
        subscription?.remove()
      }
    } else {
      const subscription = DeviceEventEmitter.addListener('ON_TRANSACTION_ID_RECEIVED', (res) => {
        navigateToTransactionDetails(res)
      })
      return () => {
        subscription?.remove()
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const screenH = Dimensions.get('screen').height
  const windowH = Dimensions.get('window').height
  const isBottomBarPresnt = screenH - windowH > 0

  useEffect(() => {
    if (!isSessionValid(sessionData)) {
      navigation?.reset({
        index: 0,
        routes: [{ name: Routes.LOGIN }],
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionData, sessAppAccessToken])

  const bottomTabNavigator = (
    isTransactionTabEnabled: BlobOptions,
    isQrEnabled: boolean,
    isSettlementTabEnabled: boolean,
    isReceivedTabVisible: boolean,
    isRefundedTabVisible: boolean,
  ) => {
    const clonedTabBar = Object.assign(Object.create(config), config)
    if (!isTransactionTabEnabled) {
      delete clonedTabBar.transactions
    }
    if (!isQrEnabled) {
      delete clonedTabBar.qr
    }

    //TODO: Settlement tab is not always visible.
    if (!isSettlementTabEnabled) {
      delete clonedTabBar.settlements
    }

    if (!isTransactionTabEnabled && !isSettlementTabEnabled) {
      delete clonedTabBar.home
    }
    const initialRoute = params?.initialRoute

    const lengthOfObjectData = Object.entries(clonedTabBar).length
    const isOddEntryOfTabElements = lengthOfObjectData === middleOrientationMinEntry
    const hideHomeTab = !isReceivedTabVisible && !isRefundedTabVisible

    //THIS CODE IS FOR THE ORIENTATION OF QR TO COME IN MIDDLE IF THE NUMBER IS ODD
    if (isOddEntryOfTabElements && isQrEnabled && isSettlementTabEnabled && hideHomeTab) {
      delete clonedTabBar?.qr
      delete clonedTabBar?.settlements
      delete clonedTabBar?.profile
      // clonedTabBar.settlements = SETTLEMENTS
      clonedTabBar.qr = QR
      clonedTabBar.profile = PROFILE
    }
    console.log('params.isLoading is ', isLoading)

    if (isLoading) {
      return null
    }

    const availableTabs = Object.keys(clonedTabBar)
    return (
      <Box {...styles.containerInner}>
        <Tab.Navigator
          detachInactiveScreens={false}
          screenOptions={{ headerShown: false }}
          tabBar={(props: any) => (
            <TabBar
              {...props}
              selectedAppLanguage={selectedAppLanguage}
              totalTabsPresent={lengthOfObjectData}
              availableTabs={availableTabs}
            />
          )}
          {...rest}>
          {availableTabs.map((key, index) => {
            return (
              <Tab.Screen
                name={key}
                key={index.toString()}
                component={clonedTabBar[key].component}
                initialParams={{
                  refundAmount: params?.refundAmount,
                  refundStatus: params?.refundStatus,
                }}
              />
            )
          })}
        </Tab.Navigator>
      </Box>
    )
  }

  const handleSetLock = () => {
    logEvent('btn_press', 'enable screen lock')
    setShowAppLock(false)
    if (isOsMobile()) {
      setAppLockLater(true)
      storeData('enableLockLater', 'true')
      ScreenLockModule?.openEnableLockScreen(async (value: boolean) => {
        storeData('lockEnabled', value ? 'true' : 'false')
        if (value) {
          setToastType(ToastType.POSITIVE)
          setMessage('Your account is now secure')
          storeData(loginStrings.userMobileNumber, userMobileNo ?? '')
          storeData('sessionData', JSON.stringify(sessionData))
        }
        setAppLockEnabled(value)

        getFromStore('lockState')
          .then((result) => {
            console.log('Async operation completed:', result)

            if (Platform.OS === 'ios' && !value && result === '1') {
              Alert.alert(
                'Enable screen lock',
                'The user disallowed screen lock last time, please enable screen lock from in More options.',
              )
            } else if (Platform.OS === 'ios' && !value) {
              storeData('lockState', 1)
            }
          })
          .catch((error) => {
            console.error('Error during async operation:', error)
          })
      })
    }
  }

  const handleCancel = () => {
    setShowAppLock(false)
    logEvent('btn_press', 'enable screen lock later')
    storeData('enableLockLater', 'true')
    setAppLockLater(true)
  }
  const hidePopup = () => {
    setAppLockLater(true)
  }

  const getFromLocal = () => {
    getFromStore('enableLockLater').then(async (value) => {
      if (value !== null) {
        const jsonValue = JSON.parse(value)
        setAppLockLater(jsonValue === 'true')
      } else {
        setAppLockLater(false)
      }
    })
  }

  useEffect(() => {
    InteractionManager.runAfterInteractions(() => {
      setShowAppLock(appLockEnabled)
    })
    getFromLocal()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const [createUserDeviceApi] = useLazyApiData(createUserDevice)

  const fetchFcmToken = async () => {
    const token = await NotificationServiceModule?.getNotificationToken()
    const deviceId = await getDeviceIdFromLib()
    createUserDeviceApi(getAppId(), 2, deviceId, token, Platform.OS === 'android' ? 1 : 2)
  }

  useEffect(() => {
    fetchFcmToken()
  }, [])

  const getDeviceIdFromLib = () => {
    return DeviceInfo.getUniqueId()
  }

  return (
    <Box {...styles.container}>
      <ModalDialogNew
        show={Platform.OS === 'android' ? showApplock : appLockEnabled}
        type={'bottom'}
        animate={true}
        onDismiss={hidePopup}
        backgroundColor={'TRANSPARENT'}>
        <Box>
          <ScreenLockDialog selectedAppLanguage={selectedAppLanguage} onPress={handleSetLock} onCancel={handleCancel} />
        </Box>
      </ModalDialogNew>
      {bottomTabNavigator(
        isTransactionTabEnabled,
        isQrEnabled,
        isSettlementTabEnabled,
        isReceivedTabVisible,
        isRefundedTabVisible,
      )}
    </Box>
  )
}

export const styles = {
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: 'WHITE',
  } as BoxProps,
  containerInner: {
    justifyContent: 'center',
    flex: 1,
    maxWidth: 820,
    bg: 'WHITE',
  } as BoxProps,
  title: { fontSize: 12, letterSpacing: 1.6, color: 'DARK_GREY' } as TextProps,
  containerStyle: { backgroundColor: 'WHITE_DIM', flex: 1 } as BoxProps,
  drawerStyle: { width: '100%', backgroundColor: 'BLACK' } as BoxProps,
  loadingStyle: {
    marginTop: 24,
    padding: 24,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  } as BoxProps,
  labelText: {
    type: 'callout',
    color: 'DARK_GREY',
    textAlign: 'center',
  } as TextProps,
  menuView: () =>
    ({
      marginTop: 0,
      zIndex: 2,
      right: 0,
      borderRadius: 4,
    } as BoxProps),
  menuViewContainer: (isFirst: boolean) =>
    ({
      zIndex: 1,
      paddingVertical: 8,
      paddingTop: isFirst ? 0 : undefined,
      overflow: 'visible',
    } as BoxProps),
  menuItemsView: () =>
    ({
      flexDirection: 'row',
      alignItems: 'center',
      height: 48,
    } as BoxProps),
  menuTitile: () =>
    ({
      color: 'WHITE',
      type: 'body1',
      weight: 'dense',
      lineHeight: 18,
      numberOfLines: 1,
      fontSize: 14,
    } as TextProps),
  imageContainerStyle: {
    paddingHorizontal: 12,
    justifyContent: 'center',
  } as BoxProps,
  imageStyle: {
    width: 50,
    height: 50,
  } as ImageProps,
  arrowContainerStyle: () =>
    ({
      paddingHorizontal: 4,
      alignItems: 'center',
      paddingTop: 2,
      justifyContent: 'center',
      right: 0,
    } as BoxProps),
  menuContentView: () =>
    ({
      flex: 1,
      backgroundColor: 'WHITE',
      minHeight: 100,
      overflow: 'auto',
      zIndex: 1,
    } as BoxProps),
  mobileDrawerStyle: { width: '100%' },
  largeScreenDrawerStyle: {
    borderRightWidth: 0,
    borderLeftWidth: 0,
    flex: 0.25,
  } as BoxProps,
  iconContainer: (isRoundedCornerTab: any, isSelected: boolean, totalTabsPresent: number) =>
    ({
      padding: 10,
      // paddingTop: isRoundedCornerTab ? 2 : 10,
      // minHeight: isRoundedCornerTab ? 60 : 0,
      // minWidth: isRoundedCornerTab ? 60 : 0,
      // borderTopColor: isSelected ? convertHexToRGBA('#000', 16) : 'TRANSPARENT',
      borderTopWidth: 0,
      justifyContent: 'center',
      alignItems: 'center',
      // borderRadius: isRoundedCornerTab ? 30 : 0,
      // backgroundColor: isRoundedCornerTab ? ('PRIMARY_LIGHT' as ColorOptions) : 'TRANSPARENT',
      zIndex: 1,
      // marginTop: isRoundedCornerTab ? -20 : 0,
      // shadowColor: isRoundedCornerTab ? 'PRIMARY' : 'TRANSPARENT',
      // shadowOffset: {
      //   width: 0,
      //   height: -2,
      // },
      // shadowOpacity: 0.25,
      // shadowRadius: 3.84,
      width: totalTabsPresent < 3 ? '70%' : undefined,
    } as BoxProps),
  tabContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    justifyContent: 'space-between',
    bg: 'WHITE',
    borderTopWidth: 0.7,
    borderTopColor: convertHexToRGBA('#000', 16),
    shadowColor: '#000' as ColorOptions,
    shadowOffset: {
      width: 0,
      height: 10,
    },
    shadowOpacity: 0.95,
    shadowRadius: 5,
  } as BoxProps,
}

export default NewTab
